<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha :items="clientesItens" v-bind:selected-items.sync="clientesSelecionados"
                            text="nome_cliente" value="id_cliente" :label="$tc('client.self', 1)" :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha :items="unidadesItens" v-bind:selected-items.sync="unidadesSelecionadas"
                            text="descricao_unidade" value="id_unidade" :label="$t('nav.registration.units')"
                            :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha :items="linhasItens" v-bind:selected-items.sync="linhasSelecionadas"
                            text="nome_linha" value="id_linha" :label="$t('nav.registration.lines')" :max-items="2" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="3">
                        <v-select v-model="intervalo" :items="intervalosSelect" item-text="text" item-value="value"
                            :label="$t('relTripPassangers.interval')"
                            :rules="[(v) => !!v || $t('relTripPassangers.rules.obligatoryInterval')]"></v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker :label="$t('relPassageirosLinhaDia.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :date-picker-props="dtiProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker :label="$t('relPassageirosLinhaDia.endDate')" v-model="dtf"
                            :time-picker-props="timeProps" :date-picker-props="dtfProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="1" md="3" align="center" style="align-self: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="setDefaultFilters" style="margin-left: 10px; margin-bottom: 5px;">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.newConsult') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable item-key="id" :headers="headers" :items="itens" :loading="loading"
            :default-multi-sort="defaultSort" :loading-text="$t('relPassageirosLinhaDia.loading')">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('relPassageirosLinhaDia.title')" :token="token" :items="itens"
                    csv-title="passageiroslinhadia" :pdf-title="$t('relPassageirosLinhaDia.title')"
                    :pdf-headers="headers" pdf-filename="passageiroslinhadia" hide-search>
                </CadastroToolbar>
            </template>
        </MerusDataTable>
    </v-container>
</template>

<script>
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';
import MerusDataTable from '../components/Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
        user: null,
        token: null,
        config: null,
        formValidado: false,
        clientes: [],
        clientesSelecionados: [],
        linhas: [],
        linhasSelecionadas: [],
        unidades: [],
        unidadesSelecionadas: [],
        dti: null,
        dtf: null,
        intervalo: 'DAY',
        timeProps: {
            useSeconds: true,
        },
        itens: [],
        loading: false,
    }),
    computed: {
        clientesItens() {
            return this.clientes;
        },
        unidadesItens() {
            return this.unidades;
        },
        linhasItens() {
            if (!this.linhas.length) {
                return [];
            }
            let list = this.linhas;
            if (this.clientesSelecionados.length) {
                const clientSet = new Set(this.clientesSelecionados.map((id) => Number(id)));
                list = list.filter((l) => l.id_cliente != null && clientSet.has(Number(l.id_cliente)));
            }
            if (this.unidadesSelecionadas.length) {
                const unitSet = new Set(this.unidadesSelecionadas.map((id) => Number(id)));
                list = list.filter((l) => {
                    const u = Array.isArray(l.unidades) ? l.unidades : [];
                    return u.some((id) => unitSet.has(Number(id)));
                });
            }
            return list;
        },
        headers() {
            return [
                { text: this.$t('relPassageirosLinhaDia.headers.periodStart'), value: 'periodo_inicio_extenso', sortable: true, filtrable: true },
                { text: this.$t('relPassageirosLinhaDia.headers.periodEnd'), value: 'periodo_fim_extenso', sortable: true, filtrable: true },
                { text: this.$t('relPassageirosLinhaDia.headers.lineCode'), value: 'cod_linha', sortable: true, filtrable: true },
                { text: this.$t('relPassageirosLinhaDia.headers.lineName'), value: 'nome_linha', sortable: true, filtrable: true },
                { text: this.$t('relPassageirosLinhaDia.headers.boardings'), value: 'qtd_embarques', sortable: true, filtrable: true },
            ];
        },
        defaultSort() {
            return [
                { value: 'indice_periodo', options: { text: this.$t('routs.increasing'), value: 1 } },
                { value: 'cod_linha', options: { text: this.$t('routs.increasing'), value: 1 } },
            ];
        },
        intervalosSelect() {
            return [
                { text: this.$t('datetime.hour'), value: 'HOUR' },
                { text: this.$t('datetime.day'), value: 'DAY' },
                { text: this.$t('datetime.month'), value: 'MONTH' },
                { text: this.$t('datetime.year'), value: 'YEAR' },
            ];
        },
        textFieldProps() {
            return {
                prependInnerIcon: 'mdi-calendar',
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
            };
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            };
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            };
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
        this.initialize();
    },
    methods: {
        initialize() {
            this.getConfig();
            this.populaClientes();
            this.populaLinhas();
            this.populaUnidades();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                }
            });
        },
        setDefaultFilters() {
            this.clientesSelecionados = [];
            this.linhasSelecionadas = [];
            this.unidadesSelecionadas = [];
            this.intervalo = 'DAY';
            this.itens = [];
            if (this.config) {
                [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
            }
        },
        populaClientes() {
            apiController.request(apiController.endpoints.getClientesativos, {
                onSuccess: (response) => {
                    this.clientes = response.data || [];
                }
            });
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                onSuccess: (response) => {
                    this.linhas = response.data || [];
                }
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [
                        { id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' },
                        ...(response.data || []),
                    ];
                }
            });
        },
        populaRelatorio() {
            this.$refs.form.validate();
            if (!this.formValidado) {
                return;
            }
            this.loading = true;
            const body = {
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf),
                intervalo: this.intervalo,
            };
            if (this.linhasSelecionadas.length) {
                body.id_linhas = this.linhasSelecionadas.map((id) => Number(id));
            }
            if (this.unidadesSelecionadas.length) {
                body.id_unidades = this.unidadesSelecionadas.map((id) => Number(id));
            }
            if (this.clientesSelecionados.length) {
                body.id_clientes = this.clientesSelecionados.map((id) => Number(id));
            }
            apiController.request(apiController.endpoints.getRelatorioembarquesporlinha, {
                data: body,
                onSuccess: (response) => {
                    const rows = response.data || [];
                    this.itens = rows.map((row) => ({
                        ...row,
                        id: `${row.indice_periodo}-${row.id_linha}`,
                    }));
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                }
            });
        },
    },
};
</script>

<style lang="">
</style>
